import { UseData } from "@/hooks/useData";
import useQueries from "@/hooks/useQueries";
import { API_URL } from "@/shared/utils/API_URL";
import { buildQuery } from "@/shared/utils/buildQuery";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

interface SoldSerial {
    serial_string: string,
    remaning_quantity: string
}

const useSoldSerial = () => {

    const { id, name } = useParams();
    const queries = useQueries();

    const soldSerialsQuery = useMemo(() => {
        if (!queries?.soldSerialsQuery || !id) return '';
        return buildQuery(queries?.soldSerialsQuery, { id: id, });
    }, [queries, id])

    const { data, isLoading } = UseData({
        apiUrl: API_URL,
        q: soldSerialsQuery,
        t: "sel",
        dependency: [id, soldSerialsQuery],
    });

    const soldSerials: SoldSerial[] = data?.data?.result || [];

    const handlePrint = () => {
        if (!soldSerials || soldSerials.length === 0) return;

        const targetOrigin = "https://w-lbl.ntelgnt.com";
        const url = `${targetOrigin}/print_serials?name=${encodeURIComponent(name || '')}&data=${true}`;

        const newWindow = window.open(url, '_blank');

        const messageListener = (event) => {
            if (event.origin !== targetOrigin) return;

            if (event.data === "READY_TO_PRINT") {
                newWindow.postMessage({
                    type: 'SERIALS_DATA',
                    payload: soldSerials
                }, targetOrigin);

                window.removeEventListener('message', messageListener);
            }
        };
        window.addEventListener('message', messageListener);
    };


    return {
        name,
        id,
        isLoading,
        soldSerials,
        soldSerialsQuery,
        handlePrint
    }
}

export default useSoldSerial;